import { render, staticRenderFns } from "./spider-legend.vue?vue&type=template&id=3a517c63"
import script from "./spider-legend.ts?vue&type=script&lang=js&external"
export * from "./spider-legend.ts?vue&type=script&lang=js&external"
import style0 from "./spider-legend.vue?vue&type=style&index=0&id=3a517c63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports